import React, { useEffect } from 'react'
import Footer from '../../components/Footer'
import Videos from '../../components/Videos'
import ScrollToTop from "../../components/ScrollToTop";
import VideosBanner from '../../components/Banner/VideosBanner';
export default function Video() {
    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Video';
    }, []);
    return (
        <>
            <ScrollToTop />
            <VideosBanner />

            <Videos />

            <Footer />
        </>
    )
}